import React from "react"

import styles from "./LShape.module.scss"

const LShape = ({ color, uncapped, variant }) => {
  const camelCase = require("camelcase")
  return (
    <div
      className={`${styles.shape} ${
        color ? styles[camelCase("" + color)] : ""
      } ${variant ? styles[camelCase("" + variant)] : ""} ${
        uncapped ? styles.uncapped : ""
      }`}
    ></div>
  )
}

LShape.defaultProps = {
  variant: "regular",
  color: "orange",
}

export default LShape
